var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view"},[_c('debug-device'),_vm._v(" "),_c('debug-video')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }